import React from 'react'
import '../css/main_style.css';
import '../css/index.css';
import MenuBar from '../manages/LoginMenu'
import SearchContent from '../manages/searchcontent'
import Toppart from '../pages/toppart'
import Footer from '../pages/Footer'

export default function Home() {
	return(		
		<div id="maincontainer">
			<Toppart />
			<MenuBar />
			<SearchContent />
			<Footer />			
		</div>		
	)
}
		